import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, TextLink } from '../../../../../components/ui';
import ModalTerms from '../../../../../components/ModalTerms/ModalTerms';
import { tipoTermoUsoEnum } from '../../../../../shared/util/enums/tipoTermoUsoEnum';
import { ContextPerson } from '../../../../../store/contexts/contextPerson';
import Config from '../../../../../shared/Config';
import howItWorksGroup from '../../../../../images/webps/howitworks-group.webp';
import styles from './HowItWorks.module.css';

function HowItWorks() {
  const { t } = useTranslation('home');
  const { pessoa } = useContext(ContextPerson);
  const [modalTermsVisible, setModalTermsVisible] = useState(false);
  const [tipoTermoUso, setTipoTermoUso] = useState(null);

  const openTermsOfUse = e => {
    e.preventDefault();
    setTipoTermoUso(tipoTermoUsoEnum.USUARIO);
    setModalTermsVisible(true);
  };

  const handleCloseModal = () => setModalTermsVisible(false);

  const isLoggedWithCompany =
    pessoa && pessoa.vinculo && pessoa.vinculo.empresa;
  const isLoggedWithoutCompany =
    pessoa && !pessoa.vinculo && Object.keys(pessoa).length !== 0;
  const isAnonymous = !pessoa || Object.keys(pessoa).length === 0;

  return (
    <section className={styles.root}>
      {modalTermsVisible && (
        <ModalTerms
          tipo={tipoTermoUso}
          modalVisible={modalTermsVisible}
          handleOk={handleCloseModal}
          handleCancel={handleCloseModal}
        />
      )}
      <div className={styles.container}>
        <div className={styles.topGrid}>
          <div className={styles.textBlock}>
            <h2 className={styles.title}>{t('HOW_IT_WORKS_TITLE')}</h2>
            <div className={styles.bodyGroup}>
              <p className={styles.body}>{t('HOW_IT_WORKS_BODY_1')}</p>
              <p className={styles.body}>{t('HOW_IT_WORKS_BODY_2')}</p>
            </div>
            <div className={styles.links}>
              <TextLink onClick={openTermsOfUse} className={styles.link}>
                {t('USE_TERMS')}
              </TextLink>
              <TextLink as={Link} to='/faq' className={styles.link}>
                {t('KNOW_MORE')}
              </TextLink>
            </div>
          </div>
          <div className={styles.imageBlock}>
            <img src={howItWorksGroup} alt='' height={220} />
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.cta}>
          <h3 className={styles.ctaTitle}>
            {isLoggedWithCompany && (
              <>
                {t('YOU_ARE_SUPPLIER')}{' '}
                <span className={styles.emphasis}>{t('SEBRAEPLACE')}</span>
              </>
            )}
            {isLoggedWithoutCompany && (
              <>
                {t('YOU_ARE_CLIENT')}{' '}
                <span className={styles.emphasis}>{t('SEBRAEPLACE')}</span>
              </>
            )}
            {isAnonymous && (
              <>
                {t('HOW_REGISTER_TITLE')}
                <span className={styles.emphasis}>{t('SEBRAEPLACE')}</span>
              </>
            )}
          </h3>
          {pessoa && pessoa.id ? (
            <Button as={Link} to='/painel'>
              {t('GO_TO_ACCOUNT')}
            </Button>
          ) : (
            <Button as='a' href={`${Config.loginUiUrl}/cadastro`}>
              {t('CREATE_ACCOUNT')}
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
